// ----------------------------------------------------------------------
// <copyright file="Izenda.ButtonGroup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ButtonGroup component
 */
!(function() {
  var React = require('react');
  var observer = require('mobx-react').observer;
  var classnames = require('classnames');

  var ButtonGroup = React.createClass({

    propTypes: {
      buttons: React.PropTypes.object,
      onChange: React.PropTypes.func,
      editorControl: React.PropTypes.object,
      onExecCommand: React.PropTypes.func
    },

    getDefaultProps: function() {
      return {
        buttons: []
      };
    },

    handleClickButton: function(item) {
      var props = this.props;

      item.isExecute && props.onExecCommand && props.onExecCommand(item.value);
      if (item.isExecute && !!props.editorControl) {
        props.editorControl.execCommand(item.value);
        return;
      }

      props.onChange && props.onChange({value: item.value}, item.value);
    },

    renderButton: function(item, index, key) {
      if (this.props.buttonsHidden && this.props.buttonsHidden[key]) {
        return null;
      }

      if (!!item.component) {
        return <item.component {...this.props} data={item} key={index} />;
      }

      var value = this.props.value || {};
      var classesBtn = classnames({
        'btn': true,
        'active': value[key]
      });

      return (
        <span key={index}>
          <a
            className={classesBtn}
            title={item.title}
            onClick={this.handleClickButton.bind(null, item)} >
            <span className={item.className}>{item.text}</span>
          </a>
          {item.breakLine ? <br /> : null}
        </span>
      );
    },

    renderButtons: function() {
      var buttons = this.props.buttons;

      return Object.keys(buttons).map(function(key, index) {
        return this.renderButton(buttons[key], index, key);
      }.bind(this));
    },

    render: function() {
      var classes = classnames('button-group', this.props.className);

      return (
        <div className={classes}>
          {this.renderButtons()}
        </div>
      );
    }
  });

  module.exports = observer(ButtonGroup);
}());



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.ButtonGroup.jsx